import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import Link from '../../Link/Link.js';
import CardText from './CardText.js';

const CardLink = (_param)=> {
    var { children , className , target , variant ='body-head' , component ='span'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className",
        "target",
        "variant",
        "component"
    ]);
    return React.createElement(CardText, {
        component: component,
        variant: variant
    }, /*#__PURE__*/ React.createElement(Link, swcHelpers.extends({
        className: classnames('card-link', className)
    }, rest), children));
};

export { CardLink as default };
//# sourceMappingURL=CardLink.js.map
